import { useEffect, useRef, useState } from "react"
import { _AbstractAccount, _AccountINFORPO, _EmployeeContract, _single, _SystemPropertyOB } from "../../../core/services/dataBean/EntityCatalog";
import { PrintJson } from "../../theme/Component/PrintJson";
import CarnetVertical from "./CarnetVertical";
import { Alert } from "../../theme/Component/Alert";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { AdminService } from "../../../core/services/AdminService";
import { FileService } from "../../../core/services/FileService";

interface Props {
    idAccount?: number;
}
export const EmployeeID = ({ idAccount = _single.getAccountID() }: Props) => {

    const { instance, setBean, bean } = useDataBean(_EmployeeContract);

    const admin = new AdminService();
    const propertie = useDataBean(_SystemPropertyOB);
    const _account = useDataBean(_AbstractAccount);
    const [acc, setAcc] = useState<any>({});
    const _file = new FileService();

    const [entity, setEntity] = useState<string>('');


    useEffect(() => {

        admin.getCompanyCatalog(null).subscribe(
            (resp: any) => {
                if (resp.DataBeanProperties.ObjectValue) {
                    let temp: any = resp.DataBeanProperties.ObjectValue;
                    if (temp.length > 0) {
                        let company: any = temp[0];
                        setEntity(company.DataBeanProperties.Name);
                    }
                }
            }
        );
        propertie.instance.getSystemProperty("IMG_BACKGROUND_CARNET").then(
            (resp) => {
                propertie.setBean(resp.SystemValue ? JSON.parse(resp.SystemValue) : {})
            }
        ).catch(err => { console.log(err) });

    }, [])

    useEffect(() => {



        _account.instance.getAccountbyID(idAccount ?? _single.getAccountID()).then(
            (resp) => {
                // setAcc({ ...resp, "PhotoUrl": _file.getImageAsBase64(_file.getUrlFile("photos", resp.Photo ?? "")) });
                setAcc({ ...resp, "PhotoUrl": _file.getUrlFile("photos", resp.Photo ?? "") });
                instance.getEmployeeContracts(_single.getCurrenYear(), _single.getCurrentMonth(), [idAccount ?? _single.getAccountID()], null, null, null, null, 2, null, null, 1, 15).then(
                    (resp) => {
                        setBean(resp.List[0].DataBeanProperties);
                    }
                ).catch(err => { toast.error("No se pudo cargar la informaición del ususario") });
            }
        ).catch(err => { toast.error("No se pudo cargar la informaición del ususario") });
    }, [idAccount])

    return (
        <div className="row">
            <div className="col-md-12 text-center">
                {bean.Nit ?
                    <CarnetVertical
                        nombre={(bean.Name1 ?? '') + " " + (bean.Name2 ?? '')}
                        apellido={(bean.Surname1 ?? '') + " " + (bean.Surname2 ?? '')}
                        grupo={bean.AppointmentName ?? "N/A"}
                        identificacion={bean.Nit}
                        rh={bean.CostingCenterName ?? "N/A"}
                        fotoUrl={acc.PhotoUrl}
                        Entity={entity}
                        Eps={bean.EPSName}
                        Arl={bean.ARPName}
                        backgroundUrl={propertie.bean.IMG ?? ""}
                        gradientStart={propertie.bean.GradientStart ?? ""}
                        gradientEnd={propertie.bean.GradientEnd ?? ""}
                    />
                    :
                    <Alert children={"El usuario no cuenta con un contrato de trabajo activo."} clase="warning text-center" />
                }
                {/* <PrintJson json={acc} /> */}
            </div>

        </div>
    )

}